import axiosClient from "system/helpers/axiosConfig";

export const postContacts = (data) => {
  return axiosClient.post(`/api/feedback/send`, data).then((r) => r.data.data);
};
